<template>
	<!-- 自動発注不可アイコン -->
	<div class="autoHatchuNgIcon mr-2 sort-item"
		v-if="ptInitData.autoHachuOption == 1 && ptInitData.productInfo.AUTO_HACHU_FLG == 0">&emsp;
	</div>
</template>
<script>
export default {
	name: 'autoHatchuNgIcon',
	props: {
		ptInitData: {
			type: Object,
			default: null
		}
	}
}
</script>